/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2024-05-17 16:28:59
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-03 15:12:28
 * @FilePath: \baishu_react_ui\src\components\BsySearchInput\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import './index.css'

class BsySearchInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
        }
        this.seachRef = React.createRef();
    }

    componentDidMount() {
        this.props.getValue && this.props.getValue(this)
        this.timeOut = null;
        if (!(this.props.defaultFocus === false)) {
            // setTimeout(() => {
            //     this.seachRef.current && this.seachRef.current.focus()
            // }, 200)
        }
    }

    changeValue = (event) => {
        this.setState({ value: event.target.value }, () => {
            this.keyUp(event)
        })
    }

    getValue = () => {
        return this.state.value
    }

    keyUp = (e) => {
        let that = this;
        if (e.keyCode === window.FX.Keys.ENTER) {
            if (this.props.onSearch) {
                this.props.onSearch(this.state.value);
            }
        } else {
            if (this.timeOut) {
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }
            this.timeOut = setTimeout(() => {
                if (that.props.onSearch) {
                    that.props.onSearch(that.state.value);
                }
                this.timeOut = null;
            }, 400);
        }
    }


    onBlur = (e) => {

        if (this.props.onBlur) {
            this.props.onBlur(e.target.value);
        }

    }

    onClearText = () => {
        this.setState({ value: '' }, () => {
            if (this.props.onSearch) {
                this.props.onSearch(this.state.value);
            }
        })
    }


    render() {
        const { placeholder, iconName, styleInput, type, onSearch, onExtElement,style } = this.props
        return (
            <div className={(type ? ("BsySearchInput " + type) : "BsySearchInput") + (onExtElement ? ' ext ' : '')} style={style}>
                <div className="inputCont">
                    <div onClick={()=>{
                        if(this.props.onSearch){
                            onSearch(this.state.value)
                        }
                    }} className="inputIcon">
                        <i className={iconName || 'icon-bsy-reportmenu-0'} />
                    </div>
                    <input onChange={this.changeValue} style={styleInput} type="text" ref={this.seachRef} placeholder={placeholder} onKeyUp={this.keyUp}
                        onBlur={this.onBlur}
                        value={this.state.value ? this.state.value : ''}
                    />
                    {
                        this.state.value ? <><i onClick={this.onClearText} className='icon-dingding-guide-close' />  {onExtElement ? <span className="split"></span> : ''}</> : ''
                    }
                    {
                        onExtElement ? onExtElement() : ''
                    }
                </div>
            </div>
        );
    }
}

export default BsySearchInput;